import { useRequiredContext } from "@redotech/react-util/context";
import LayersIcon from "@redotech/redo-icons/layers-three-02.svg";
import LayersIconFilled from "@redotech/redo-icons/layers-three-02_filled.svg";
import RefreshIcon from "@redotech/redo-icons/refresh-ccw-03_filled.svg";
import RefreshIconOutline from "@redotech/redo-icons/refresh-cw-02.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { useLocation } from "react-router-dom";

export const InventoryItem = memo(function InventoryItem() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const location = useLocation();
  const team = useRequiredContext(TeamContext);

  // Check if marketplace is enabled for this team
  const isMarketplaceEnabled = team.settings.recommerce?.marketplace ?? false;

  // Check if forecasting is enabled for this team
  const isForecastingEnabled = team.settings.ims?.forecastingEnabled ?? false;

  const isRecommerceChildSelected =
    location.pathname.includes("/liquidation/") ||
    location.pathname.endsWith("/liquidation");

  // Check if any product child routes are selected
  const isProductChildSelected =
    location.pathname.includes("/products/") ||
    location.pathname.endsWith("/products");

  // Check if suppliers routes are selected
  const isSuppliersSelected =
    location.pathname.includes("/suppliers") ||
    location.pathname.endsWith("/suppliers");

  // Check if purchase orders routes are selected
  const isPurchaseOrdersSelected =
    location.pathname.includes("/purchase-orders") ||
    location.pathname.endsWith("/purchase-orders");

  return (
    <>
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: `${routes.inventoryManagementBaseUrl}/products`,
        }}
        anyChildSelected={isProductChildSelected}
        FilledIcon={LayersIconFilled}
        friendlyName="Inventory"
        id="products"
        UnfilledIcon={LayersIcon}
      >
        <RedoSecondaryNavItem
          action={{
            type: "link",
            href: `${routes.inventoryManagementBaseUrl}/products/pricing-rules`,
          }}
          friendlyName="Pricing Rules"
          id="pricing-rules"
        />
        <RedoSecondaryNavItem
          action={{
            type: "link",
            href: `${routes.inventoryManagementBaseUrl}/products/adjustments`,
          }}
          friendlyName="Inventory Adjustments"
          id="inventory-adjustments"
        />
        {isForecastingEnabled && (
          <>
            <RedoSecondaryNavItem
              action={{
                type: "link",
                href: `${routes.inventoryManagementBaseUrl}/products/forecasting`,
              }}
              friendlyName="Forecasting"
              id="forecasting"
            />
            <RedoSecondaryNavItem
              action={{
                type: "link",
                href: `${routes.inventoryManagementBaseUrl}/suppliers`,
              }}
              anyChildSelected={isSuppliersSelected}
              friendlyName="Suppliers"
              id="suppliers"
            />
            <RedoSecondaryNavItem
              action={{
                type: "link",
                href: `${routes.inventoryManagementBaseUrl}/purchase-orders`,
              }}
              anyChildSelected={isPurchaseOrdersSelected}
              friendlyName="Purchase Orders"
              id="purchase-orders"
            />
          </>
        )}
      </RedoSecondaryNavItem>

      {isMarketplaceEnabled && (
        <RedoSecondaryNavItem
          action={{ type: "button" }}
          anyChildSelected={isRecommerceChildSelected}
          FilledIcon={RefreshIcon}
          friendlyName="Recommerce"
          id="recommerce"
          isFolder
          UnfilledIcon={RefreshIconOutline}
        >
          <RedoSecondaryNavItem
            action={{
              type: "link",
              href: `${routes.inventoryManagementBaseUrl}/liquidation/dashboard`,
            }}
            friendlyName="Dashboard"
            id="liquidation-dashboard"
          />
          <RedoSecondaryNavItem
            action={{
              type: "link",
              href: `${routes.inventoryManagementBaseUrl}/liquidation/products`,
            }}
            friendlyName="All listings"
            id="liquidation-all-products"
          />
        </RedoSecondaryNavItem>
      )}
    </>
  );
});
